module.exports = __webpack_public_path__ + "static/media/close.ee7f48ed.svg";